@if (parentFormGroup?.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
  [ngClass]="{
        'enabled-clear-selection': enableClearSelection &&
                                   parentFormGroup?.controls[controlName].value &&
                                   parentFormGroup?.controls[controlName].status !== 'DISABLED',
      }"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label [class.error]="error" class="label"
        >{{ label }}@if (isRequired) {
        <span>*&nbsp;</span>
        }:
        @if (labelBadge) { <span class="field-label-badge" data-testid="field-label-badge">{{ labelBadge }}</span> }
      </mat-label>
    }
    <mat-select
      #select
      (keydown)="$event.preventDefault()"
      (openedChange)="onOpenedChange($event)"
      [formControlName]="controlName"
      [multiple]="enableMultiple"
      [compareWith]="compareWithValue"
    [ngClass]="{
      'enabled-clear-selections':
        parentFormGroup?.controls[controlName].status !== 'DISABLED' &&
        enableClearSelection && parentFormGroup?.getRawValue()[controlName]
    }"
      [panelClass]="optionsPanelClassName"
      [panelWidth]="panelWidth"
      [placeholder]="placeholder"
      class="select"
      disableOptionCentering
      panelClass="testClass"
      >
      @if (!enableRegistryDetailedOptionView && !enableMultiple && hasTagOptions) {
        <mat-select-trigger>
          {{ getLabelForSelectedOption() }}
        </mat-select-trigger>
      }
      @if (enableRegistryDetailedOptionView) {
        <mat-select-trigger>
          {{ getHeadingForSelectedOption() }}
        </mat-select-trigger>
      }
      @if (!enableRegistryDetailedOptionView && showCount && enableMultiple) {
        <mat-select-trigger>
          {{ (parentFormGroup?.controls[controlName]?.value?.length || 0) + ' ' + selectionString }}
        </mat-select-trigger>
      }
      @if (loading) {
        <mat-option class="dropdown-loading" disabled>
          <mat-spinner [diameter]="20" class="dropdown-loader" mode="indeterminate"> </mat-spinner>
        </mat-option>
      } @else {
        <!--      SEARCH SECTION-->
        @if ((options?.length || enableAddItem) && enableSearch) {
          <form [formGroup]="searchForm">
            <div class="filter-section search-section">
              <div class="search">
                <mat-icon svgIcon="search"></mat-icon>
                <input (keydown)="$event.stopPropagation()" formControlName="text" matInput placeholder="Search" />
              </div>
            </div>
          </form>
        }
        @if (enableAddNew && addNewClicked.observers.length > 0) {
          <mat-option class="hidden-option" disabled style="display: none; height: 0; min-height: 0; padding: 0; margin: 0; overflow: hidden;"></mat-option>
          <div
            (click)="onAddNewClick($event)"
            class="add-new-option flex justify-start items-center"
            >
            <span class="add-new-plus">+</span><span>{{ addNewLabel }}</span>
          </div>
        }
        @if (filteredOptions?.length) {
          <div>
            @if (enableAddItem) {
              <div
                (click)="addItem()"
                [class.disabled]="addText?.length === 0 || disabledClass"
                class="add-item flex justify-start items-center"
                >
                <span class="flex justify-start items-center">
                  <mat-icon [svgIcon]="'plus'" class="icon mr-[5px]" />
                  Add {{ addText ? addText : 'item' }}
                </span>
              </div>
            }
            @if (!enableDetailedOptionView && !enableRegistryDetailedOptionView) {
              @for (option of filteredOptions; track option; let i = $index) {
                @if (option?.value === 'ADD_NEW' && addNewClicked.observers.length > 0) {
                } @else if (!option['children']) {
                  <mat-option
                    [disabled]="(option?.value !== -1 && optionsDisabled) || option?.disabled"
                    [value]="option?.value"
                    [class.add-new-option]="option?.value === 'ADD_NEW'"
                    class="single-select-option"
                    >
                    {{ sentenceCase ? (option?.label | sentenceCase) : option?.label }}
                    @if (option?.tag) {
                      <span class="option-tag-pill">{{ option?.tag }}</span>
                    }
                  </mat-option>
                }
                @if (option['children']) {
                  <mat-option [disabled]="true" [value]="option?.value" class="single-select-option">
                    {{ sentenceCase ? (option?.label | sentenceCase) : option?.label }}
                  </mat-option>
                  @for (child of option['children']; track child) {
                    <mat-option
                      [disabled]="child.disabled"
                      [value]="child.value"
                      class="single-select-option child-option"
                      >
                      {{ sentenceCase ? (child.label | sentenceCase) : child.label }}
                    </mat-option>
                  }
                }
              }
              @if (!options?.length) {
                <mat-option class="no-data" disabled> No options available </mat-option>
              }
            }
            @if (enableDetailedOptionView) {
              @for (option of filteredOptions; track option; let i = $index) {
                <mat-option
                  [disabled]="(option?.value !== -1 && optionsDisabled) || option?.disabled"
                  [value]="option?.id"
                  class="detailed-single-select-option"
                  >
                  <div class="each-item flex justify-start items-center gap-[16px]">
                    <div class="left flex justify-start items-center">
                      <div class="icon-wrapper">
                        <mat-icon svgIcon="daily-report-page-menu-bid-item" />
                      </div>
                    </div>
                    <div class="right flex flex-col justify-center items-start">
                      <div class="bid-item-heading text-type-6">Bid item {{ option?.item }}</div>
                      <div class="h-[1px]">&nbsp;</div>
                      <div class="description text-type-14">{{ option?.description }}</div>
                    </div>
                  </div>
                </mat-option>
              }
            }
            @if (enableRegistryDetailedOptionView) {
              @for (option of filteredOptions; track option; let i = $index) {
                @if (option?.value !== 'ADD_NEW') {
                  <mat-option
                    [disabled]="(option?.value !== -1 && optionsDisabled) || option?.disabled"
                    [value]="option?.id"
                    class="detailed-single-select-option"
                    >
                    <div class="each-item flex justify-start items-center gap-[16px]">
                      <div class="left flex justify-start items-center">
                        <div class="icon-wrapper">
                          <mat-icon svgIcon="daily-report-page-menu-bid-item" />
                        </div>
                      </div>
                      <div class="right flex flex-col justify-center items-start">
                        <div class="bid-item-heading text-type-6">{{ option?.heading }}</div>
                        <div class="h-[1px]">&nbsp;</div>
                        <div class="description text-type-14">{{ option?.title }}</div>
                      </div>
                    </div>
                  </mat-option>
                }
              }
            }
          </div>
        } @else {
          @if (enableAddItem) {
            <div
              (click)="addItem()"
              [class.disabled]="addText?.length === 0 || disabledClass"
              class="add-item flex justify-start items-center"
              >
              <span class="flex justify-start items-center">
                <mat-icon [svgIcon]="'plus'" class="icon mr-[5px]" />
                Add {{ addText ? addText : 'item' }}
              </span>
            </div>
          }
          <mat-option class="no-data" disabled> No options available </mat-option>
        }
      }
    </mat-select>
    @if (parentFormGroup?.controls[this.controlName]?.status !== 'DISABLED') {
      <mat-icon
        class="suffix-icon"
        matSuffix
        svgIcon="chevron-light"
        />
    }
    @if (
      defaultValue && defaultValue.length
      ? parentFormGroup?.getRawValue()[controlName]?.join(',') !== defaultValue.join(',')
      : parentFormGroup?.controls[this.controlName]?.status !== 'DISABLED' &&
      ((!enableMultiple && enableClearSelection && parentFormGroup?.getRawValue()[controlName]) ||
      (enableMultiple && enableClearSelection && parentFormGroup?.getRawValue()[controlName]?.length))
      ) {
      <mat-icon
        (click)="clearSelection($event)"
        class="clear-selection"
        svgIcon="close"
        matSuffix
        matTooltip="Clear"
        />
    }
    @if (error) {
      <mat-error>{{ error }}</mat-error>
    }
    @if (!error && hint) {
      <mat-hint class="text-type-14">{{ hint }}</mat-hint>
    }
  </mat-form-field>
}
